import { Link } from "react-router-dom";
import { appPaths } from "../../Routes";
import Button from "../Button";
import SectionTitle from "../SectionTitle";
import { EvidenceForRegion, EvidenceForSector } from "../../api/models/Dashboard";
import BySectorEvidence from "./BySectorEvidence";

export type EvidenceSectionProps = {
    evidenceMissingCount: number;
    evidenceExpiringInNext30DaysCount: number;
    evidenceInDateCount: number;
    dataSourceEvidenceByRegion: EvidenceForRegion[];
    evidenceBySector: EvidenceForSector[];
};

const EvidenceSection = ({
    evidenceBySector
}: EvidenceSectionProps) => {

    return (
        <>
            <SectionTitle title="Evidence">
                <div className="flex flex-wrap sm:ml-auto gap-3 sm:space-y-0 mt-4">
                    <Link
                        className="block"
                        to={`${appPaths.evidence}?statusFilter=ExpiringWithin30Days`}
                    >
                        <Button variant="outline">View breakdown</Button>
                    </Link>
                </div>
            </SectionTitle>
            <BySectorEvidence
                    emissionsSourceEvidenceBySector={evidenceBySector}
                />
        </>
    );
};

export default EvidenceSection;
